import React from 'react';
import {
  Grid,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { NOSPACE_REGEX } from "../../utils/constants";
import { MESSAGE } from "../../utils/validationMessage";
import { STATUS_OPTIONS_LIST } from "../../utils/constants";

const EditableForm = ({ 
  initialData, 
  onSubmit, 
  validationSchema, 
  fields = [],
  submitButtonText = "Save Changes",
  enableReinitialize = true 
}) => {
  return (
    <Formik
      initialValues={initialData}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize={enableReinitialize}
    >
      {({ values, handleChange, handleBlur, touched, errors, setFieldValue }) => (
        <Form>
          <Grid container spacing={2}>
            {fields.map((field, index) => (
              <Grid item xs={12} sm={field.gridSize || 4} key={index}>
                {field.type === 'select' ? (
                  <TextField
                    name={field.name}
                    label={field.label}
                    size="small"
                    fullWidth
                    select
                    value={values[field.name] || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched[field.name] && Boolean(errors[field.name])}
                    helperText={touched[field.name] && errors[field.name]}
                    SelectProps={{
                      native: field.native || true,
                    }}
                  >
                    {field.options?.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                ) : (
                  <TextField
                    name={field.name}
                    label={field.label}
                    size="small"
                    fullWidth
                    type={field.type || 'text'}
                    multiline={field.multiline || false}
                    rows={field.rows || 1}
                    value={values[field.name] || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched[field.name] && Boolean(errors[field.name])}
                    helperText={touched[field.name] && errors[field.name]}
                  />
                )}
              </Grid>
            ))}
            <Grid item xs={12}>
              <Button type="submit" variant="contained">
                {submitButtonText}
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default EditableForm;